import {useCallback, useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {reset} from '../Redux/Slice/fertilitySlice';
import {getAllFertility} from '../Redux/Thunk/fertiltyActions';

const useFertility = (filters, pagination, loaderchange, popupalert, popuptext) => {
  const [dataCount, setDataCount] = useState(0);
  const [tableData, setTableData] = useState([]);

  const fettilityData = useSelector(state => state.fertility.fertility);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllFertility());
    dispatch(reset());
  }, []);

  useEffect(() => {
    setTableData(fettilityData);
  }, [fettilityData]);

  const prevData = useRef(null);

  const fetchData = useCallback(async () => {
    const dataPayload = {
      page: pagination.pageIndex,
      page_size: pagination.pageSize,
      search: filters.search,
      result: filters.result || '',
      treatment_type: filters.treatment_type || '',
      beta_hcg_test_date_from: filters.beta_hcg_test_date_from || '',
      beta_hcg_test_date_to: filters.beta_hcg_test_date_to || ''
    };

    if (JSON.stringify(prevData.current) === JSON.stringify(dataPayload)) return;
    prevData.current = dataPayload;
    loaderchange('true');

    try {
      const data = await dispatch(getAllFertility(dataPayload)).unwrap();
      const fertility = data.data;
      console.log('total_count -->', data.total_count);
      if (fertility.length > 0) {
        setTableData(fertility);
        setDataCount(data.total_count);
      } else {
        popupalert('true');
        setTableData([]);
        setDataCount(0);
        popuptext('No Data Available');
        setTimeout(() => popupalert('false'), 2000);
      }
    } catch (error) {
      console.error('Error fetching patient data:', error);
      popupalert('true');
      popuptext('Failed to fetch data');
      setTimeout(() => popupalert('false'), 2000);
    } finally {
      loaderchange('false');
    }
  }, [filters, pagination]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return {tableData, dataCount, fetchData};
};

export default useFertility;
